var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isValid)?_c('QuestionMarkCta',{staticClass:"overlay-info-question-cta",class:{ 'overlay-info-question-cta--checkbox': _vm.isCheckbox },on:{"click":_vm.onClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }